import { createStore, applyMiddleware, combineReducers } from "redux";
import thunkMiddleware from "redux-thunk";
import {
  routerMiddleware,
  routerReducer,
  RouterState,
} from "react-router-redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { reducer as formReducer, FormState } from "redux-form";

import appReducer from "./screens/app/reducer";
import history from "./history";
import {
  IAppReducer,
  IOrdersReducer,
  IInvoicesReducer,
  IQualityReportsReducer,
  IInspectionReportsReducer,
  IAccountStatementsReducer,
  IReceiptsReturnsReducer,
  ISettingsReducer,
  ICultivationAdvicesReducer,
  INotificationsReducer,
  IDeliveriesReducer,
  IMyDeliveriesReducer,
  IPreferencesReducer,
  IAreaStatementReducer,
  ICompanyInfoReducer,
} from "models/index";
import orders from "./screens/orders/reducer";
import invoices from "./screens/invoices/reducer";
import accountStatements from "./screens/accountStatements/reducer";
import qualityReports from "./screens/qualityReport/reducer";
import inspectionReports from "./screens/inspectionReport/reducer";
import receiptsReturns from "./screens/receiptsReturns/reducer";
import settings from "./screens/settings/reducer";
import cultivationAdvices from "./screens/myCultivationAdvice/reducer";
import notifications from "./screens/myNotifications/reducer";
import deliveries from "./screens/deliveries/reducer";
import myDeliveries from "./screens/deliveryNotes/reducer";
import preferences from "./screens/deliveryNotes/preferences/reducer";
import areaStatements from "./screens/areaStatementView/reducer";
import companyInformation from "./screens/companyInformation/reducer";

// @ts-ignore
const middleware = routerMiddleware(history);

export interface IReducer {
  router: RouterState;
  form: FormState;
  app: IAppReducer;
  orders: IOrdersReducer;
  invoices: IInvoicesReducer;
  accountStatements: IAccountStatementsReducer;
  qualityReports: IQualityReportsReducer;
  inspectionReports: IInspectionReportsReducer;
  settings: ISettingsReducer;
  receiptsReturns: IReceiptsReturnsReducer;
  cultivationAdvices: ICultivationAdvicesReducer;
  notifications: INotificationsReducer;
  deliveries: IDeliveriesReducer;
  myDeliveries: IMyDeliveriesReducer;
  preferences: IPreferencesReducer;
  areaStatements: IAreaStatementReducer;
  companyInformation: ICompanyInfoReducer;
}

const reducers = combineReducers<IReducer>({
  router: routerReducer,
  form: formReducer,
  app: appReducer,
  orders,
  invoices,
  accountStatements,
  qualityReports,
  inspectionReports,
  receiptsReturns,
  settings,
  cultivationAdvices,
  notifications,
  deliveries,
  myDeliveries,
  preferences,
  areaStatements,
  companyInformation,
});

const store = createStore(
  reducers,
  composeWithDevTools(applyMiddleware(thunkMiddleware, middleware))
);

export default store;
